import React from 'react';
import { ServicePageLayout } from '../../components/feature/service-page/ServicePageLayout';

const MotorolaServicePage: React.FC = () => {
  return (
    <ServicePageLayout
      seo={{
        title: "Motorola Repair Kochi - Motorola Service Center Kerala | Device Doctor",
        description: "Professional Motorola repair services in Kochi, Kerala. Expert Motorola device repair for Edge series, G series, Moto series. Screen replacement, battery repair, software issues. Quality service with warranty.",
        keywords: "motorola repair kochi, motorola service center kerala, motorola screen repair, motorola battery replacement, moto repair vyttila, motorola edge repair",
        structuredData: { "@context": "https://schema.org", "@type": "Service", "name": "Motorola Repair Services", "brand": { "@type": "Brand", "name": "Motorola" } }
      }}
      hero={{
        title: "Motorola Service Centre in Kochi",
        subtitle: "Reliable, genuine & fast Motorola mobile repairs with certified technicians, genuine parts, same-day service & 1-month warranty.",
        stats: [{ value: '500+', label: 'Motorola Repairs' }, { value: '4.9★', label: 'Customer Rating' }, { value: 'Same Day', label: 'Service Available' }],
        backgroundImage: "/assets/motorola-hero-bg.jpg"
      }}
      serviceList={{
        introParagraph: "Comprehensive repair solutions for all Motorola devices with genuine parts and expert technicians.",
        services: [
          { id: 'display', title: 'Display & Touchscreen Repairs', icon: 'ri-smartphone-line', description: 'Get your Motorola display back to life with our precision repair services.', image: '/assets/android-repair-new.jpg', subServices: [{ title: 'Screen Repairs', description: 'Solutions for cracked glass, flicker issues, and water damage.', features: ['Cracked screen replacement', 'Touch calibration', 'Backlight issues', 'Blank screen restoration'] }] }
        ]
      }}
      features={{
        title: "Why Choose Device Doctor for Motorola Repairs",
        subtitle: "Experience the difference with our professional service, genuine parts, and customer-first approach.",
        badgeText: "Why Choose Us",
        items: [
          { icon: 'ri-award-line', title: 'Certified Motorola Technicians', description: 'Our team consists of certified Motorola technicians with years of hands-on experience.' },
          { icon: 'ri-shield-check-line', title: '100% Genuine Parts', description: 'We use only original Motorola-certified parts for every replacement to ensure optimal performance.' },
          { icon: 'ri-time-line', title: 'Same-Day Service', description: 'Most display, battery, and charging repairs are completed within the same day.' },
          { icon: 'ri-money-dollar-circle-line', title: 'Transparent Pricing', description: 'Clear estimates before repair with no hidden charges.' },
          { icon: 'ri-truck-line', title: 'All-Kerala Courier Service', description: 'Send your device safely from anywhere in Kerala via our courier service.' },
          { icon: 'ri-customer-service-2-line', title: '1-Month Service Warranty', description: 'All repairs come with a comprehensive 1-month service warranty.' }
        ]
      }}
      models={{
        title: "Motorola Models We Service",
        subtitle: "We service all Motorola smartphones, including the latest releases and discontinued models.",
        categories: [
          { title: 'Moto G-Series', icon: 'ri-smartphone-line', models: ['Moto G13', 'Moto G52', 'Moto G82'], color: 'bg-blue-500' },
          { title: 'Moto Edge Series', icon: 'ri-smartphone-fill', models: ['Moto Edge 30', 'Moto Edge 30 Pro', 'Moto Edge+'], color: 'bg-purple-500' }
        ]
      }}
      testimonials={{
        items: [
          { name: 'Abin K.', location: 'Kochi', rating: 5, text: 'My Moto Edge 30 had a cracked screen. They fixed it the same day — excellent work!', device: 'Moto Edge 30', service: 'Screen Replacement' },
          { name: 'Sneha P.', location: 'Thrissur', rating: 5, text: 'I sent my Motorola via courier from Calicut. Got it repaired perfectly and returned within three days.', device: 'Moto G52', service: 'Courier Service' }
        ]
      }}
      faq={{
        items: [
          { question: 'How long does a Motorola repair take?', answer: 'Most display or charging repairs are completed within the same day. Courier repairs are typically completed and returned within 2–4 days.' },
          { question: 'Are the spare parts genuine?', answer: 'Yes, we use only original Motorola-certified parts for every repair.' }
        ]
      }}
      cta={{
        title: "Ready to Repair Your Motorola?",
        subtitle: "Get your Motorola phone repaired by Kerala's trusted service experts. Contact Device Doctor – Best Motorola Service Centre in Kochi.",
        themeColor: "blue"
      }}
    />
  );
};

export default MotorolaServicePage;
export { MotorolaServicePage };